module.exports = __webpack_public_path__ + "static/media/mic_off.dde7230e.svg";